export default __webpack_public_path__ + "static/DSC_0017-811290889e06813fd3d88f396a11e351.jpg";